// Import the 3D model files (.glb format)
// These are binary GLTF files containing 3D geometry, materials, and named mesh nodes
import iphone11 from 'assets/iphone-11.glb';    // iPhone 11: Frame, Screen, Logo nodes (flat hierarchy)
import macbookPro from 'assets/macbook-pro.glb'; // MacBook Pro: Keyboard→(Body,Touchbar), Frame→(Logo,Screen) (hierarchical)

/**
 * Animation types for different device models
 * Each animation type corresponds to a specific behavior in the Model component
 */
export const ModelAnimationType = {
  SpringUp: 'spring-up',      // iPhone: Entire model slides up vertically with spring physics
  LaptopOpen: 'laptop-open',  // MacBook: Screen assembly rotates from closed (90°) to open (0°)
};

/**
 * Device model configurations
 * These define the properties and behavior of each 3D model
 * 
 * IMPORTANT: The 'width' and 'height' values correspond to the texture dimensions
 * that will be applied to the 'Screen' mesh node within each GLTF file
 */
const models = {
  phone: {
    url: iphone11,                              // Path to iphone-11.glb file
    width: 374,                                 // iPhone screen width for texture aspect ratio
    height: 512,                                // iPhone screen height for texture aspect ratio  
    position: { x: 0, y: 0, z: 0 },            // Initial 3D position in scene space
    animation: ModelAnimationType.SpringUp,     // Slides up from below with bounce
  },
  laptop: {
    url: macbookPro,                            // Path to macbook-pro.glb file  
    width: 1280,                                // MacBook screen width for texture aspect ratio
    height: 800,                                // MacBook screen height for texture aspect ratio
    position: { x: 0, y: 0, z: 0 },            // Initial 3D position in scene space
    animation: ModelAnimationType.LaptopOpen,   // Screen opens with realistic hinge rotation
  },
};

export default models;
